import i18n from '@dms/i18n';

/** Translated language name without the locale code (e.g. 'cs-CZ' -> 'Czech'). */
export const getLocaleLanguageLabel = (locale: string): string => {
  const [language] = locale.split('-');

  return i18n.t(`entity.tenant.labels.language-${language}`);
};
